<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <span
      class="title-icon"
      [style.--k-bg]="corSelecionada()?.corFundo"
      [style.--k-bg-dark]="corSelecionada()?.corFundoDark"
      [style.--k-fg]="corSelecionada()?.corConteudo"
      [style.--k-fg-dark]="corSelecionada()?.corConteudoDark">
      <mat-icon class="material-symbols-outlined">{{ iconeNome(idKanbanIcone) }}</mat-icon>
    </span>
  </div>
  <div class="modal-header-titles">
    <div class="modal-eyebrow">{{ isEdicao ? 'EDITAR ETAPA' : 'NOVA ETAPA' }}</div>
    <div class="d-flex flex-wrap align-items-center gap-2">
      <h2 class="modal-title">{{ nome || 'Informe o nome da etapa' }}</h2>
      <span class="status-badge badge-cinza">
        <span class="material-symbols-outlined">build</span>
        Ordem de serviço
      </span>
    </div>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content
  class="modal-content"
  [style.--k-bg]="corSelecionada()?.corFundo"
  [style.--k-bg-dark]="corSelecionada()?.corFundoDark"
  [style.--k-fg]="corSelecionada()?.corConteudo"
  [style.--k-fg-dark]="corSelecionada()?.corConteudoDark">
  <section class="kb-secao">
    <div class="section-title">
      <span class="status-badge badge-cinza">1</span>
      <mat-icon class="material-symbols-outlined">badge</mat-icon>
      <span>Identidade</span>
    </div>
    <p class="section-sub-title">Como esta etapa aparece no board de ordens de serviço.</p>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Nome da etapa</mat-label>
      <input
        matInput
        [(ngModel)]="nome"
        [disabled]="isFixo"
        placeholder="Ex.: Em andamento"
        [maxlength]="tamanhoMaximoNome" />
      @if (isFixo) {
        <mat-icon matSuffix class="material-symbols-outlined nome-lock" matTooltip="Nome fixo do sistema"
          >lock</mat-icon
        >
      }
      <mat-hint align="end">{{ nome.length }}/{{ tamanhoMaximoNome }}</mat-hint>
    </mat-form-field>

    <div class="d-flex flex-wrap align-items-start gap-3 mt-3">
      <div class="caixa-escolha cor">
        <span class="d-block small fw-semibold mb-2">Cor</span>
        <div class="d-flex flex-wrap gap-2">
          @for (c of data.cores; track c.idKanbanCor) {
            <button
              type="button"
              class="btn-cor"
              [class.sel]="idKanbanCor === c.idKanbanCor"
              (click)="selecionarCor(c.idKanbanCor)"
              [matTooltip]="c.nome"
              [attr.aria-label]="c.nome"
              [style.--dot-l]="c.corPrincipal"
              [style.--dot-d]="c.corPrincipalDark"></button>
          }
        </div>
      </div>

      <div class="caixa-escolha icone">
        <span class="d-block small fw-semibold mb-2">Ícone</span>
        <div class="d-flex flex-wrap gap-2">
          @for (ic of data.icones; track ic.idKanbanIcone) {
            <button
              type="button"
              class="btn-icone"
              [class.sel]="idKanbanIcone === ic.idKanbanIcone"
              (click)="selecionarIcone(ic.idKanbanIcone)"
              [matTooltip]="ic.nomeIcone">
              <mat-icon class="material-symbols-outlined">{{ ic.nomeIcone }}</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
  </section>

  @if (isEspecial) {
    <div class="nota-fixo-wrap">
      <app-alert-card type="neutral" icon="lock">
        Etapa especial: fica fora do fluxo linear, não participa de Inicial → Final, não é reordenável e
        recebe cards apenas das etapas que a tiverem como destino. Você pode ajustar nome, cor, ícone e
        visibilidade.
      </app-alert-card>
    </div>
  } @else if (isFixo) {
    <div class="nota-fixo-wrap">
      <app-alert-card type="neutral" icon="lock">
        Etapa fixa do sistema: o nome e a posição no fluxo não mudam e ela não pode ser excluída nem
        desativada. Você pode ajustar cor, ícone, visibilidade, destinos permitidos, perfis, campos
        obrigatórios e motivo.
      </app-alert-card>
    </div>
  }

  @if (!isEspecial) {
    <section class="kb-secao">
      <div class="section-title">
        <span class="status-badge badge-cinza">2</span>
        <mat-icon class="material-symbols-outlined">flag_circle</mat-icon>
        <span>Papel no fluxo</span>
      </div>
      <p class="section-sub-title">Define onde a ordem de serviço nasce e onde ela é encerrada.</p>

      <div class="toggle-content">
        <span [matTooltip]="tooltipInicialBloqueado">
          <mat-slide-toggle
            class="app-toggle-compact"
            [(ngModel)]="isInicial"
            [disabled]="!!tooltipInicialBloqueado">
            <mat-icon class="material-symbols-outlined toggle-label-icon">play_circle</mat-icon> Etapa inicial
          </mat-slide-toggle>
        </span>
        <span class="info-text">A ordem de serviço nasce nesta etapa (apenas 1).</span>
      </div>
      @if (inicialAtual) {
        <app-alert-card type="warning"
          >Ao salvar, "{{ inicialAtual.nome }}" deixa de ser a etapa inicial.</app-alert-card
        >
      }
      <div class="toggle-content">
        <mat-slide-toggle class="app-toggle-compact" [(ngModel)]="isFinal">
          <mat-icon class="material-symbols-outlined toggle-label-icon">flag</mat-icon> Etapa final
        </mat-slide-toggle>
        <span class="info-text">Encerra a ordem de serviço — pode haver várias.</span>
      </div>
    </section>
  }

  <section class="kb-secao">
    <div class="section-title">
      <span class="status-badge badge-cinza">{{ numeroPassoVisibilidade }}</span>
      <mat-icon class="material-symbols-outlined">visibility</mat-icon>
      <span>Visibilidade dos cards</span>
    </div>
    <p class="section-sub-title">Quem enxerga esta etapa e os cards que estão nela.</p>

    <mat-radio-group [(ngModel)]="visibilidadeTodos" class="d-flex gap-4 mb-2">
      <mat-radio-button [value]="true">Todos os perfis</mat-radio-button>
      <mat-radio-button [value]="false">Perfis específicos</mat-radio-button>
    </mat-radio-group>
    @if (!visibilidadeTodos) {
      <app-select-pesquisavel
        [control]="visibilidadeControl"
        label="Perfis que podem visualizar esta etapa"
        [offlineList]="data.perfis"
        idField="idPerfil"
        nameField="nome"
        [multiple]="true"
        [showBadges]="true"
        subscriptSizing="dynamic">
      </app-select-pesquisavel>
      <div class="small text-muted">Lista vazia = todos os perfis podem visualizar.</div>
    }

    <app-alert-card type="info">
      Além desta configuração, continua valendo o escopo do usuário: quem vê só as próprias ordens de serviço
      continua vendo apenas as suas, mesmo em etapa liberada para o seu perfil.
    </app-alert-card>
  </section>

  @if (!isEspecial) {
    <section class="kb-secao">
      <div class="section-title">
        <span class="status-badge badge-cinza">4</span>
        <mat-icon class="material-symbols-outlined">route</mat-icon>
        <span>Movimentações permitidas</span>
      </div>
      <p class="section-sub-title">
        A partir de {{ nome || 'esta etapa' }}, o card pode ir para {{ qtdMovimentacoes }} destino(s).
      </p>

      <div class="mb-3">
        <div class="grupo-titulo d-flex align-items-center small fw-semibold">
          <mat-icon class="material-symbols-outlined">build</mat-icon>
          Ordem de serviço
        </div>

        @for (d of destinos; track d.idEtapaKanban) {
          <div class="transicao" [class.sel]="isDestino(d.idEtapaKanban)">
            <div class="transicao-head d-flex align-items-center gap-2 fw-semibold">
              <mat-slide-toggle
                class="app-toggle-compact"
                [checked]="isDestino(d.idEtapaKanban)"
                [attr.aria-label]="'Permitir mover para ' + d.nome"
                (change)="toggleDestino(d.idEtapaKanban, $event.checked)"></mat-slide-toggle>
              <span
                class="dest-icone"
                [style.--k-bg]="corPorId(d.idKanbanCor)?.corFundo"
                [style.--k-bg-dark]="corPorId(d.idKanbanCor)?.corFundoDark"
                [style.--k-fg]="corPorId(d.idKanbanCor)?.corConteudo"
                [style.--k-fg-dark]="corPorId(d.idKanbanCor)?.corConteudoDark">
                <mat-icon class="material-symbols-outlined">{{ iconeNome(d.idKanbanIcone) }}</mat-icon>
              </span>
              <span class="transicao-nome">{{ d.nome }}</span>
              @if (isDestinoEspecial(d)) {
                <span
                  class="mini-badge badge-cinza"
                  matTooltip="Etapa especial: o card não sai dela por arraste.">
                  <mat-icon class="material-symbols-outlined">auto_awesome</mat-icon> especial
                </span>
              }
              @if (d.isFinal) {
                <span class="mini-badge badge-vermelho">final</span>
              }
            </div>
            @if (isDestino(d.idEtapaKanban)) {
              <div class="transicao-perfis">
                <span class="perfis-mover-label d-flex align-items-center fw-semibold mb-2">
                  <mat-icon class="material-symbols-outlined">lock_person</mat-icon> Perfis autorizados a
                  mover
                </span>
                <app-select-pesquisavel
                  [control]="perfilControl(d.idEtapaKanban)"
                  label="Todos os perfis podem mover"
                  hint="Lista vazia = todos os perfis podem mover."
                  [offlineList]="data.perfis"
                  idField="idPerfil"
                  nameField="nome"
                  [multiple]="true"
                  [showBadges]="true"
                  subscriptSizing="dynamic">
                </app-select-pesquisavel>
              </div>
            }
          </div>
        }
      </div>

      <app-alert-card type="info">
        Marcar um destino define apenas a permissão de movimentação manual do card e não dispara automações.
      </app-alert-card>
    </section>

    <section class="kb-secao">
      <div class="section-title">
        <span class="status-badge badge-cinza">5</span>
        <mat-icon class="material-symbols-outlined">fact_check</mat-icon>
        <span>Campos obrigatórios nesta etapa</span>
      </div>
      <p class="section-sub-title">
        O que precisa estar preenchido para salvar uma ordem de serviço nesta etapa.
      </p>

      <div class="motivos-bloco">
        <span class="motivos-bloco-label d-inline-flex align-items-center fw-semibold mb-2">
          <mat-icon class="material-symbols-outlined">playlist_add</mat-icon> Campos adicionais
        </span>
        @if (camposOptions.length) {
          <app-select-pesquisavel
            [control]="camposControl"
            label="Nenhum campo obrigatório"
            [offlineList]="camposOptions"
            idField="idCampoAdicional"
            nameField="nome"
            badgeField="tipo"
            [multiple]="true"
            [showBadges]="true"
            subscriptSizing="dynamic">
          </app-select-pesquisavel>
        } @else {
          <span class="small text-muted">Nenhum campo adicional cadastrado em Campos adicionais.</span>
        }
      </div>

      <app-alert-card type="info">
        Os campos escolhidos são validados ao salvar uma ordem de serviço nesta etapa — tanto ao mover o card
        para cá quanto ao editar uma ordem que já está nela. Sem eles preenchidos, o sistema não conclui o
        salvamento e indica o que falta.
      </app-alert-card>
    </section>

    <section class="kb-secao">
      <div class="section-title">
        <span class="status-badge badge-cinza">6</span>
        <mat-icon class="material-symbols-outlined">edit_note</mat-icon>
        <span>Motivo obrigatório</span>
      </div>
      <p class="section-sub-title">Peça uma justificativa sempre que um card entrar nesta etapa.</p>

      <div class="toggle-content">
        <mat-slide-toggle class="app-toggle-compact" [(ngModel)]="isMotivoObrigatorio">
          Exigir informação ao entrar nesta etapa
        </mat-slide-toggle>
        <span class="info-text"
          >Ao mover um card para esta etapa, o usuário deverá selecionar um motivo antes de confirmar.</span
        >
      </div>

      @if (isMotivoObrigatorio) {
        <div class="motivos-bloco">
          <span class="motivos-bloco-label d-inline-flex align-items-center fw-semibold mb-2">
            <mat-icon class="material-symbols-outlined">list</mat-icon> Motivos disponíveis nesta etapa
          </span>
          <app-select-pesquisavel
            [control]="motivosControl"
            label="Todos os motivos ativos"
            [offlineList]="motivosAtivos"
            idField="idMotivoTransicao"
            nameField="nome"
            [multiple]="true"
            [showBadges]="true"
            subscriptSizing="dynamic">
          </app-select-pesquisavel>
          <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 mt-2">
            <span class="small text-muted">{{ resumoMotivos }}</span>
            <button
              type="button"
              class="link-gerenciar btn-link d-inline-flex align-items-center gap-1 text-nowrap fw-semibold"
              (click)="gerenciarMotivos()">
              <mat-icon class="material-symbols-outlined">open_in_new</mat-icon> Gerenciar motivos
            </button>
          </div>
        </div>
      }
    </section>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-actions">
  @if (isEdicao && !isFixo) {
    <button mat-button class="btn-excluir" (click)="excluir()">
      <mat-icon class="material-symbols-outlined">delete</mat-icon> Excluir
    </button>
  }
  <span class="spacer"></span>
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <span [matTooltip]="nome.trim() ? '' : 'Informe o nome da etapa para salvar.'">
    <button
      mat-flat-button
      class="btn-primary btn-spinner"
      [class.btn-loading]="isSaving"
      [disabled]="isSaving || !nome.trim()"
      [attr.aria-label]="isSaving ? 'Salvando' : 'Salvar'"
      (click)="salvar()">
      Salvar
      @if (isSaving) {
        <mat-spinner diameter="20"></mat-spinner>
      }
    </button>
  </span>
</mat-dialog-actions>
